import { tsRestClient } from "@api/tsRest";

import { ICompanyTableControls } from "@store/filters/filter.types";

import { isValidPatentStatusArray } from "@utilities/typeguards";

export const listCompanies = async ({ filters, pagination, sort }: Omit<ICompanyTableControls, "selection">) => {
  const maxEmployeesValue = filters.maxEmployees === Infinity ? 1_000_000_000 : filters.maxEmployees;

  const { body, status } = await tsRestClient.companies.getAllCompanies({
    query: {
      ...filters,
      maxEmployees: maxEmployeesValue,
      sort,
      ...pagination,
    },
  });

  if (status !== 200) {
    throw new Error("Failed to get companies");
  }

  return body;
};

export const getDataSources = async (companyId: string) => {
  const { body, status } = await tsRestClient.companies.getSources({ params: { id: companyId } });
  if (status !== 200) {
    throw new Error("Failed to get sources from company");
  }
  // No need for type assertion here since the return type is already defined
  return body;
};

interface ICompanyPatentsQuery {
  companyId: string;
  field?: string;
  limit: number;
  page: number;
  patentStatus: string[];
  search?: string;
  searchId?: string;
  sort?: string;
  technologyId?: string;
}

export const getCompanyPatents = async ({
  companyId,
  field,
  limit,
  page,
  patentStatus,
  search,
  searchId,
  sort,
  technologyId,
}: ICompanyPatentsQuery) => {
  if (!isValidPatentStatusArray(patentStatus)) {
    throw new Error("Invalid patent statuses provided.");
  }

  const { body, status } = await tsRestClient.companies.getPatents({
    params: { companyId },
    query: {
      field,
      limit,
      page,
      patentStatus,
      search,
      searchId,
      sort,
      technologyId,
    },
  });
  if (status !== 200) {
    throw new Error("Failed to get company patents");
  }
  return body;
};

export const getCompany = async (companyId: string) => {
  const { body, status } = await tsRestClient.companies.getCompany({ params: { id: companyId } });
  if (status !== 200) {
    throw new Error("Failed to get company");
  }
  return body;
};
